import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ProductOnUser from 'common-ts/dist/models/Product';

export interface PersonalSizeFlow {
    status: UIOverlayViewStatus,
    personalSizeScreen: string,
    key2CategoryResultShown: string,

    statusPromo: UIOverlayViewStatus,
    statusHowTo: UIOverlayViewStatus,

    payloadPromo: {
        sizeData: any,
        productDetail: ProductOnUser | undefined,
    },

    currentViewedBodyMeasCreationDateTime: string,
}

// Define the initial state using that type
const initialState: PersonalSizeFlow = {
    status: UIOverlayViewStatus.OffAndReady,
    personalSizeScreen: 'ukuranPersonalCurrentDetail',
    key2CategoryResultShown: '',

    statusPromo: UIOverlayViewStatus.OffAndReady,
    statusHowTo: UIOverlayViewStatus.OffAndReady,

    payloadPromo: {
        sizeData: undefined,
        productDetail: undefined,
    },

    currentViewedBodyMeasCreationDateTime: '',
}

export const overlayPersonalSizeSlice = createSlice({
    name: 'overlayPersonalSize',
    initialState,
    reducers: {
        closeOverlayAndReset: (state) => {
            state.status = UIOverlayViewStatus.OffAndReady;
            state.personalSizeScreen = 'ukuranPersonalCurrentDetail';
            state.key2CategoryResultShown = '';
        },

        closeOverlayAndResetPromo: (state) => {
            state.statusPromo = UIOverlayViewStatus.OffAndReady;
        },

        closeOverlayAndResetHowTo: (state) => {
            state.statusHowTo = UIOverlayViewStatus.OffAndReady;
        },

        updateCurrentScreen: (state, action: PayloadAction<string>) => {
            state.personalSizeScreen = action.payload;
        },

        setKey2CategoryResultShown: (state, action: PayloadAction<string>) => {
            state.key2CategoryResultShown = action.payload;
        },

        openOverlay: (state) => {
            state.status = UIOverlayViewStatus.On;
            state.personalSizeScreen = 'ukuranPersonalCurrentDetail';
        },
        
        openOverlayPromo: (state, action: PayloadAction<{
            sizeData: any,
            productDetail: ProductOnUser | undefined,
        }>) => {
            state.statusPromo = UIOverlayViewStatus.On;
            state.payloadPromo = action.payload;
        },

        openOverlayHowTo: (state) => {
            state.statusHowTo = UIOverlayViewStatus.On;
        },

        setViewedBodyMeas: (state, action: PayloadAction<string>) => {
            state.currentViewedBodyMeasCreationDateTime = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { closeOverlayAndReset, openOverlay, openOverlayPromo, openOverlayHowTo, closeOverlayAndResetHowTo,
    updateCurrentScreen, setKey2CategoryResultShown, closeOverlayAndResetPromo, setViewedBodyMeas } = overlayPersonalSizeSlice.actions

export default overlayPersonalSizeSlice.reducer